import * as components from 'vuetify/components';


const MainRoutes = {
    path: '/main',
    meta: {
        requiresAuth: true
    },
    redirect: '/main',
    component: () => import('@/layouts/full/FullLayout.vue'),
    children: [
        
        
        {
            name: 'Application Process',
            path: '/',
            component: () => import('@/views/StarterPage.vue')
        },
        {
            name: 'User Insights',
            path: '/user-insights',
            component: () => import('@/views/dashboard/UserInsights.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
           
        },
        {
            name: 'Brochures',
            path: '/brochures',
            component: () => import('@/views/dashboard/Brochure.vue'),
             meta: { roles: ['Admin', 'Super Admin' , 'Student'] },
           
        },
        {
            name: 'Announcements',
            path: '/announcements',
            component: () => import('@/views/announcements/Announcements.vue'),
             meta: { roles: ['Admin', 'Super Admin', 'Student'] },
        },
        {
            name: 'TicketMonitoring',
            path: '/ticket-monitoring',
            component: () => import('@/views/dashboard/TicketMonitoring.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
           
        },
        {
            name: 'Unassigned Tickets',
            path: '/inbox/tickets/available-tickets',
            component: () => import('@/views/inbox/tickets/Unassigned.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Open tickets',
            path: '/inbox/tickets/open',
            component: () => import('@/views/inbox/tickets/Open.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Closed tickets',
            path: '/inbox/tickets/closed',
            component: () => import('@/views/inbox/tickets/Closed.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Assigned Open tickets',
            path: '/inbox/tickets/assigned/open',
            component: () => import('@/views/inbox/tickets/AssignedOpen.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },  // Only Admin and Super Admin can access this route}
        },
        {
            name: 'Assigned Closed tickets',
            path: '/inbox/tickets/assigned/closed',
            component: () => import('@/views/inbox/tickets/AssignedClosed.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'My Open Tickets',
            path: '/inbox/my-tickets/open',
            component: () => import('@/views/inbox/my-tickets/Open.vue'),
             meta: { roles: ['Student'] },
           
        },
        {
            name: 'My Closed Tickets',
            path: '/inbox/my-tickets/closed',
            component: () => import('@/views/inbox/my-tickets/Closed.vue'),
            meta: { roles: ['Student'] },
        },
        {
            name: 'Discussion',
            path: '/inbox/tickets/thread/:ticket',
            component: () => import('@/views/inbox/tickets/ThreadV2.vue'),
            beforeEnter: (to, from, next) => {
                const id = to.params.ticket;
            
                // Allow only if tagid is NOT purely numeric
                if (!/^\d+$/.test(id)) {
                  next();
                } else {
                  next({ name: 'Error' }); // or any fallback route
                }
              }
        },
        {
            name: 'Admin[Discussion]',
            path: '/inbox/tickets/admin/thread/:ticket',
            component: () => import('@/views/inbox/tickets/ThreadV2.vue'),
            beforeEnter: (to, from, next) => {
                const id = to.params.ticket;
            
                // Allow only if tagid is NOT purely numeric
                if (!/^\d+$/.test(id)) {
                  next();
                } else {
                  next({ name: 'Error' }); // or any fallback route
                }
              }
        },
        {
            name: 'soa-generator',
            path: '/soa-generator',
            component: () => import('@/views/soa/Soa.vue'),
            
        },
        {
            name: 'readme',
            path: '/readme',
            component: () => import('@/views/readme/Index.vue'),
        },
        {
            name: 'Change Password',
            path: '/settings/change-password',
            component: () => import('@/views/settings/tabs/ChangePassword.vue'),
            meta: { roles: ['Student', 'Admin', 'Super Admin'] },
        },
        {
            name: 'Forms',
            path: '/forms',
            component: () => import('@/views/forms/Index.vue')
        },
        
        {
            name: 'Create Application',
            path: '/my-applications/create/:tagid',
            component: () => import('@/views/my-applications/CreateV2.vue'),
            beforeEnter: (to, from, next) => {
                const tagid = to.params.tagid;
            
                // Allow only if tagid is NOT purely numeric
                if (!/^\d+$/.test(tagid)) {
                  next();
                } else {
                  next({ name: 'Error' }); // or any fallback route
                }
              },
        },
         {
            name: 'all-applicants',
            path: '/applications/all',
            component: () => import('@/views/applications/Applicants.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'update-applicant',
            path: '/applications/update/:id',
            component: () => import('@/views/applications/UpdateApplication.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        // {
        //     name: 'Pending Applications',
        //     path: '/applications/processing',
        //     component: () => import('@/views/applications/PendingSubmissions.vue'),
        //     meta: { roles: ['Admin', 'Super Admin'] },
        // },
        // {
        //     name: 'Submitted Applications',
        //     path: '/applications/submitted',
        //     component: () => import('@/views/applications/Submitted.vue'),
        //      meta: { roles: ['Admin', 'Super Admin'] },
        // },
        {
            name: 'Queued Admitted Applications',
            path: '/applications/queued-admitted',
            component: () => import('@/views/applications/Queued.vue'),
        },
        {
            name: 'Admitted Applications',
            path: '/applications/admitted',
            component: () => import('@/views/applications/Admitted.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Declined Applications',
            path: '/applications/declined',
            component: () => import('@/views/applications/Declined.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },

        // {
        //     name: 'GWA Computation',
        //     path: '/applications/for-gwa',
        //     component: () => import('@/views/applications/Gwa.vue'),
        //      meta: { roles: ['Admin', 'Super Admin'] },
        // },
        // {
        //     name: 'Computed GWA',
        //     path: '/applications/computed-gwa',
        //     component: () => import('@/views/applications/ComputedGwa.vue'),
        //      meta: { roles: ['Admin', 'Super Admin'] },
        // },

        {
            name: 'Transmittal',
            path: '/applications/transmittal',
            component: () => import('@/views/applications/Transmittal.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Transmittal Batches',
            path: '/applications/transmittal-batches',
            component: () => import('@/views/applications/TransmittalBatches.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        
        {
            name: 'View Submitted Application',
            path: '/applications/submitted/:id',
            component: () => import('@/views/applications/ViewSubmitted.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },

        {
            name: 'View Pending Application',
            path: '/applications/pending/:id',
            component: () => import('@/views/applications/ViewSubmitted.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'View Applications',
            path: '/applications/view/:tagid',
            component: () => import('@/views/applications/ViewApplication.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'DOST Scholars',
            path: '/dost-scholars',
            component: () => import('@/views/dost-scholars/DostScholars.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'DOST Scholar Statuses',
            path: '/dost-scholars/settings/statuses',
            component: () => import('@/views/dost-scholars/DostScholarStatuses.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'View DOST Scholar',
            path: '/dost-scholars/:id',
            component: () => import('@/views/dost-scholars/ViewDostScholar.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
        },
        // {
        //     name: 'Transmittal to College',
        //     path: '/applications/transmittal-college/ocs/:college',
        //     component: () => import('@/views/applications/TransmittalOcs.vue'),
            
        // },
       

        {
            name: 'Tranmisttal Error',
            path: '/errors/404',
            component: () => import('@/views/applications/Error.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },
        {
            name: 'Transmittal List',
            path: '/applications/transmittal-batches/:id',
            component: () => import('@/views/applications/TransmittalResult.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
            
        },
        {
            name: 'QR Code Generator',
            path: '/qr-code-generator',
            component: () => import('@/views/qr-code/QrCode.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },


         {
            name: 'URL Shortener',
            path: '/url-shortener',
            component: () => import('@/views/url-shortener/Index.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },

         {
            name: 'guidebook',
            path: '/guidebook',
            component: () => import('@/views/guidebook/Index.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },

         {
            name: 'manage-users',
            path: '/manage-users',
            component: () => import('@/views/manage-users/Index.vue'),
             meta: { roles: ['Admin', 'Super Admin'] },
        },

        {
            name: 'test',
            path: '/testing',
            component: () => import('@/views/inbox/Support.vue'),
        },
        // {
        //     name: 'account-settings',
        //     path: '/settings/account',
        //     component: () => import('@/views/settings/AccountSettings.vue'),
        //     meta: { roles: ['Student', 'Admin', 'Super Admin'] },
        // },
        {
            path: '/settings',
            component: () => import('@/views/settings/AccountSettings.vue'), // Optional wrapper for tabs
            meta: { roles: ['Student', 'Admin', 'Super Admin'] },
            redirect: '/settings/account',
            children: [
                {
                    path: 'account',
                    name: 'account-settings',
                    component: () => import('@/views/settings/tabs/Profile.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                {
                    path: 'security',
                    name: 'security',
                    component: () => import('@/views/settings/tabs/ChangePassword.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                {
                    path: 'devices',
                    name: 'devices',
                    component: () => import('@/views/settings/tabs/Devices.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                {
                    path: 'notifications',
                    name: 'notifications',
                    component: () => import('@/views/settings/tabs/Notifications.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                }
            ]
        },
        {
            path: '/readme',
            component: () => import('@/views/readme/Index.vue'), // Optional wrapper for tabs
            meta: { roles: ['Student', 'Admin', 'Super Admin'] },
            redirect: '/readme/general-requirements',
            children: [
                {
                    path: 'general-requirements',
                    name: 'general-reaquirements',
                    component: () => import('@/views/readme/tabs/GeneralRequirements.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                {
                    path: 'application-process',
                    name: 'application-process',
                    component: () => import('@/views/readme/tabs/ApplicationProcess.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                {
                    path: 'payment-options',
                    name: 'payment-options',
                    component: () => import('@/views/readme/tabs/PaymentOption.vue'),
                    meta: { roles: ['Student', 'Admin', 'Super Admin'] }
                },
                
            ]
        },

        {
         
            name: 'reports-applications',
             path: '/reports/applications',
            component: () => import('@/views/reports/Applications.vue'),
            meta: { roles: ['Admin', 'Super Admin'] }
        },
         {
           
            name: 'reports-inquiries',
             path: '/reports/inquiries',
            component: () => import('@/views/reports/Inquiries.vue'),
            meta: { roles: ['Admin', 'Super Admin'] }
        },
        
        {
            name: 'college-reports',
            path: '/dashboard/college/:college',
            component: () => import('@/views/dashboard/CollegeReport.vue'),
            meta: { roles: ['Admin', 'Super Admin'] },
            

        }

       
    ],
};

export default MainRoutes;
